import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const NotificationBadgeContainer = styled.div`
  position: relative;
  left: 12px;
  top: -32px;
  width: min-content;
`;

export const NotificationListContainer = styled.div`
  position: absolute;
  top: 52px;
  width: 350px;
  margin-left: -295px;
  background: ${ThemePrisma.colors.gray[1]};
  border-radius: 0 0 ${ThemePrisma.borderRadius.small} ${ThemePrisma.borderRadius.small};
  border-top: 1px solid ${ThemePrisma.colors.lightblue[7]};
  overflow: hidden;
  z-index: 10;

  .scroll-container {
    max-height: 50vh;
  }

  .item:not(:last-child) {
    border-bottom: 1px solid ${ThemePrisma.colors.gray[4]};
  }
`;

export const StyledNotificationContainer = styled.div`
  position: relative;
`;
